<template>
  <div class="row" v-if="isSuperUser || isStaffUser || isPartner">
    <div class="col-12">
      <loading-card v-if="isFirstLoad" :title="title" />
      <card v-else :title="title">
        <template v-slot:raw-content>
          <div class="card-body">
            <div class="row">
              <div
                class="col-md-4 left-column"
                :class="{ 'd-none': !(isSuperUser || isPartner) }"
              >
                <button class="btn btn-sm btn-info" @click="showCreateModal">
                  Create
                </button>
              </div>

              <div class="col-md-4">
                <div class="activation-toggle">
                  Show expired contracts
                  <toggle-button
                    :sync="true"
                    v-model="showExpired"
                    @change="toggleShowExpired"
                    :color="{ checked: '#229863', unchecked: '#CB3247' }"
                  />
                </div>
              </div>

              <div class="col-md-4" :class="{ 'offset-md-8': !isSuperUser }">
                <fg-input
                  type="text"
                  placeholder="Search"
                  v-model="searchTerm"
                  @keyupEnter="fetchOrganizations(1)"
                  @clickedIcon="fetchOrganizations(1)"
                  addonRightIcon="search"
                  :iconClasses="['clickable']"
                >
                </fg-input>
              </div>
            </div>
          </div>
          <div v-if="isLoading" class="text-center text-muted">
            <div class="spinner-border large-spinner" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <table v-else class="table table-hover">
            <tbody v-if="organizations.length > 0">
              <tr
                v-for="(item, index) in organizations"
                :key="index"
                :class="{ 'table-active': isSelectedRow(item) }"
              >
                <td class="clickable" @click="selectRow(item)">
                  <input
                    type="radio"
                    class="clickable"
                    :value="item"
                    v-model="selectedOrganization"
                  />
                </td>
                <td class="clickable" @click="selectRow(item)">
                  {{ item.name }}
                </td>
                <td class="clickable" @click="selectRow(item)">
                  {{ item.root_group.name }}
                </td>
                <td class="clickable" @click="selectRow(item)">
                  {{ item.contract_start | prettyDate }} -
                  {{ item.contract_end | prettyDate }}
                </td>
                <td>
                  <button class="btn btn-sm" @click="showEditModalFor(item)">
                    Edit
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center">No organizations found.</td>
              </tr>
            </tbody>
          </table>
          <div class="left-column">
            <b-pagination
              v-model="currentPage"
              :total-rows="count"
              :per-page="perPage"
              @change="fetchOrganizations"
            />
          </div>
        </template>
      </card>
    </div>
    <create-organization-modal @hasUpdate="fetchOrganizations" />
    <edit-organization-modal
      v-if="editOrganization"
      :organization="editOrganization"
    />
  </div>
</template>

<script>
import CreateOrganizationModal from "../Modals/CreateOrganizationModal.vue";
import EditOrganizationModal from "../Modals/EditOrganizationModal.vue";
import LoadingCard from "../Cards/LoadingCard.vue";
import config from "../../constants/config";
import { mapGetters } from "vuex";
import ActivationToggle from "../Inputs/ActivationToggle.vue";

export default {
  name: "OrganizationTable",
  components: {
    CreateOrganizationModal,
    EditOrganizationModal,
    LoadingCard,
    ActivationToggle,
  },
  props: {
    isActive: Boolean,
  },
  data() {
    return {
      title: "Organizations",
      isLoading: false,
      isFirstLoad: false,
      currentPage: 1,
      searchTerm: "",
      editOrganization: null,
      showExpired: false
    };
  },
  async created() {
    this.isFirstLoad = true;
    await this.fetchOrganizations(this.currentPage);
    this.isFirstLoad = false;
  },
  methods: {
    async fetchOrganizations(page) {
      if (page) {
        this.currentPage = page;
      }
      let params = {
        skip: this.skip,
        limit: this.perPage,
      };
      if (this.searchTerm) {
        params.name = this.searchTerm;
      }
      if (!this.showExpired) {
        params.hide_expired = !this.showExpired;
      }

      this.isLoading = true;
      await this.$store.dispatch("organization/fetchOrganizations", params);
      this.isLoading = false;
    },
    showCreateModal() {
      this.$bvModal.show(config.CREATE_ORG_MODAL_ID);
    },
    showEditModalFor(organization) {
      this.editOrganization = organization;
      this.$nextTick(() => {
        this.$bvModal.show(config.EDIT_ORG_MODAL_ID);
      });
    },
    selectRow(organization) {
      this.selectedOrganization = organization;
    },
    isSelectedRow(organization) {
      return (
        this.selectedOrganization &&
        organization.id == this.selectedOrganization.id
      );
    },
    toggleShowExpired() {
      this.fetchOrganizations(1);
    }
  },
  computed: {
    ...mapGetters("organization", ["organizations", "count", "perPage"]),
    ...mapGetters("user", ["isSuperUser", "isStaffUser", "isPartner"]),
    skip() {
      return (this.currentPage - 1) * this.perPage;
    },
    selectedOrganization: {
      get() {
        return this.$store.state.organization.selectedOrganization;
      },
      set(value) {
        this.$store.commit("organization/selectOrganization", value);
        this.$store.commit("group/topLevelGroup", value.root_group);
      },
    },
  },
};
</script>
